import React from 'react';
import WidgetWrapper from '../widgets/WidgetWrapper';
import SeriesPopularityWidget from '../widgets/SeriesPopularityWidget';
import IRatingDistributionWidget from '../widgets/IRatingDistributionWidget';
import LapTimesBoxPlotWidget from '../widgets/LapTimesBoxPlotWidget';
import CareerStatsWidget from '../widgets/CareerStatsWidget';
import SeriesSafetyWidget from '../widgets/SeriesSafetyWidget';

const WIDGET_COMPONENTS = {
  series_popularity: SeriesPopularityWidget,
  irating_distribution: IRatingDistributionWidget,
  lap_times_boxplot: LapTimesBoxPlotWidget,
  career_stats: CareerStatsWidget,
  series_safety: SeriesSafetyWidget,
};

const WIDGET_TITLES = {
  series_popularity: 'Series Popularity',
  irating_distribution: 'iRating Distribution',
  lap_times_boxplot: 'Lap Times',
  career_stats: 'Career Stats',
  series_safety: 'Series Safety',
};

function WidgetSlot({ position, widget, onClick, onRemove, onExpand, onConfigChange, isDragOver, isDragging, onDragStart, onDragOver, onDrop, onDragEnd }) {
  const dragOverClass = isDragOver ? 'widget-slot-drag-over' : '';

  if (!widget) {
    // Empty slot - show plus icon
    return (
      <div
        className={`widget-slot widget-slot-empty ${dragOverClass}`}
        onClick={onClick}
        onDragOver={onDragOver}
        onDrop={onDrop}
      >
        <div className="widget-slot-plus">
          <span>+</span>
        </div>
        <div className="widget-slot-hint">Add Widget</div>
      </div>
    );
  }

  // Filled slot - render widget
  const WidgetComponent = WIDGET_COMPONENTS[widget.widgetType];
  const title = WIDGET_TITLES[widget.widgetType] || 'Widget';
  const expandState = widget.expandState || 0;

  if (!WidgetComponent) {
    return (
      <div className="widget-slot widget-slot-error">
        <span>Unknown widget type</span>
      </div>
    );
  }

  // Get CSS class based on expand state
  const getExpandClass = () => {
    switch (expandState) {
      case 1: return 'widget-expanded-wide';
      case 2: return 'widget-expanded-full';
      default: return '';
    }
  };

  const draggingClass = isDragging ? 'widget-slot-dragging' : '';

  return (
    <div
      className={`widget-slot-container ${getExpandClass()} ${dragOverClass} ${draggingClass}`}
      draggable="true"
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <WidgetWrapper
        title={title}
        onRemove={onRemove}
        onExpand={onExpand}
        expandState={expandState}
      >
        <WidgetComponent
          config={widget.config || {}}
          expandState={expandState}
          onConfigChange={(newConfig) => onConfigChange(position, newConfig)}
        />
      </WidgetWrapper>
    </div>
  );
}

export default WidgetSlot;
